import { render, staticRenderFns } from "./Remarkable.vue?vue&type=template&id=793bf6e3&scoped=true"
import script from "./Remarkable.vue?vue&type=script&lang=js"
export * from "./Remarkable.vue?vue&type=script&lang=js"
import style0 from "./Remarkable.vue?vue&type=style&index=0&id=793bf6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bf6e3",
  null
  
)

export default component.exports